var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    {
      staticClass: "section-invert reverse-sm",
      staticStyle: { "margin-top": "0px !important" },
      attrs: { id: "medic-assistance" }
    },
    [
      _c(
        "b-col",
        { staticClass: "content my-auto", attrs: { md: "12", lg: "6" } },
        [
          _c("h3", [_vm._v(_vm._s(_vm.$t("medical-assistance.title")))]),
          _vm._v(" "),
          _c("p", { staticClass: "text-info" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("medical-assistance.subtitle")) +
                "\n      "
            ),
            _c("br"),
            _c("br"),
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("medical-assistance.content")) +
                "\n      "
            ),
            _c("br"),
            _c("br"),
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("medical-assistance.available-consultations")) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "subtitle" }, [
            _c("div", { staticClass: "subtitle-list subtitle-list mt-sm-5" }, [
              _c("div", [
                _c(
                  "p",
                  [
                    _c("v-icon", {
                      attrs: { large: "" },
                      domProps: {
                        textContent: _vm._s("mdi-video-plus-outline")
                      }
                    }),
                    _vm._v(
                      _vm._s(_vm.$t("medical-assistance.video")) +
                        "\n          "
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "p",
                  [
                    _c("v-icon", {
                      attrs: { large: "" },
                      domProps: {
                        textContent: _vm._s("mdi-cellphone-information")
                      }
                    }),
                    _vm._v(
                      _vm._s(_vm.$t("medical-assistance.phone-attention")) +
                        "\n          "
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "p",
                  [
                    _c("v-icon", {
                      attrs: { large: "" },
                      domProps: {
                        textContent: _vm._s(
                          "mdi-file-document-multiple-outline"
                        )
                      }
                    }),
                    _vm._v(
                      _vm._s(
                        _vm.$t("medical-assistance.written-consultation")
                      ) + "\n          "
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "p",
                  [
                    _c("v-icon", {
                      attrs: { large: "" },
                      domProps: {
                        textContent: _vm._s("mdi-comment-processing-outline")
                      }
                    }),
                    _vm._v(
                      _vm._s(_vm.$t("medical-assistance.chat")) + "\n          "
                    )
                  ],
                  1
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "router-link",
            { attrs: { to: "/opensaludprime/asistenciamedica" } },
            [
              _c(
                "base-button",
                {
                  staticClass: "btn-more-info-white",
                  staticStyle: { color: "white" },
                  attrs: { white: "", outline: "", href: "" }
                },
                [
                  _c("span", { staticStyle: { color: "white" } }, [
                    _vm._v(_vm._s(_vm.$t("more-info-btn")))
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("b-col", { attrs: { md: "12", lg: "6" } }, [
        _c("div", { staticClass: "col-bg ml-lg-auto" })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6790c61a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6790c61a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/MedicalAssistance.vue
// module id = 3987
// module chunks = 35